export const SET_SEARCH_RESULTS = "SET_SEARCH_RESULTS";
export const SET_WORKPLACE_SEARCH_RESULTS = "SET_WORKPLACE_SEARCH_RESULTS";
export const SELECT_BUSINESS = "SELECT_BUSINESS";
export const SELECT_EMPLOYEE = "SELECT_EMPLOYEE";
